import React from "react";
import { TypeRadio, DayChips } from "./ServiceControls";

const TRAINING_OPTIONS = [
  ["none", "Not selected", null, (k) => `${k}-type-none`],
  ["individual", "Individual sessions", "$100 ea", (k) => `checkbox-service-${k}`],
  ["daily", "Daily Package (5)", "$350", (k) => `${k}-type-daily`],
  ["double", "Double Daily (10)", "$500", (k) => `${k}-type-double`],
];

const FEEDBACK_OPTIONS = [
  ["none", "Not selected", null, "feedback-type-none"],
  ["individual", "Individual", "$50 ea", "feedback-type-individual"],
  ["daily", "Daily (5)", "$150", "feedback-type-daily"],
];

export function TrainingSection({ svcKey, s, groupName, onType, onCycleDay }) {
  const label = svcKey === "football" ? "Individual Soccer Training" : "Individual Goalkeeper Training";
  return (
    <div>
      <h4 className="font-bold text-[#03281B] mb-1">{label}</h4>
      <p className="text-xs text-slate-500 mb-3">40-minute sessions. Maximum 2 individual sessions per day.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {TRAINING_OPTIONS.map(([value, text, price, tid]) => (
          <TypeRadio key={value} name={groupName} value={value} current={s.type} label={text} price={price} onChange={onType} testid={tid(svcKey)} />
        ))}
      </div>
      {s.type === "individual" && (
        <div className="mt-3">
          <p className="text-xs text-slate-500 mb-2">Tap a day to add a session (tap again for 2, once more to clear):</p>
          <DayChips prefix={svcKey} max={2} countFor={(d) => s.days?.[d] || 0} onClick={onCycleDay} />
        </div>
      )}
    </div>
  );
}

export function DevelopmentSection({ on, onToggle }) {
  return (
    <div>
      <h4 className="font-bold text-[#03281B] mb-1">Complete Personalized Development Package</h4>
      <p className="text-xs text-slate-500 mb-3">Premium: 5 daily feedback sessions + written report + video analysis + individual development plan.</p>
      <label data-testid="checkbox-service-development" className={`flex items-center justify-between gap-3 rounded-xl border-2 px-4 py-3 cursor-pointer ${on ? "border-[#F3C242] bg-amber-50" : "border-[#E2EBF0] bg-white"}`}>
        <div className="flex items-center gap-3">
          <input type="checkbox" checked={on} onChange={onToggle} className="accent-[#008057] w-4 h-4" />
          <span className="text-sm font-semibold text-[#03281B]">Add Development Package</span>
        </div>
        <span className="font-display font-bold text-[#008057]">$250</span>
      </label>
    </div>
  );
}

export function FeedbackSection({ fb, disabled, groupName, onType, onToggleDay }) {
  return (
    <div className={disabled ? "opacity-50 pointer-events-none" : ""}>
      <h4 className="font-bold text-[#03281B] mb-1">Personalized Feedback with Written Report</h4>
      <p className="text-xs text-slate-500 mb-3">Maximum one feedback session per day. {disabled && "Already included in the Development Package."}</p>
      <div className="grid sm:grid-cols-3 gap-2">
        {FEEDBACK_OPTIONS.map(([value, text, price, tid]) => (
          <TypeRadio key={value} name={groupName} value={value} current={fb.type} label={text} price={price} onChange={onType} testid={tid} />
        ))}
      </div>
      {fb.type === "individual" && (
        <div className="mt-3"><DayChips prefix="feedback" max={1} countFor={(d) => fb.days?.[d] || 0} onClick={onToggleDay} /></div>
      )}
    </div>
  );
}

export function MealsSection({ mealDays, td, dietary, onToggle, onDietary }) {
  return (
    <div>
      <h4 className="font-bold text-[#03281B] mb-1">Meal Service &middot; $30/day</h4>
      <p className="text-xs text-slate-500 mb-3">
        {td.size === 0
          ? "Meal service is exclusively available to participants who have booked individual soccer or goalkeeper training on the selected day."
          : "Select meal days (only days with a soccer or goalkeeper training booking are available). 5-day total: $150."}
      </p>
      <DayChips prefix="meal" max={1} countFor={(d) => (mealDays.includes(d) ? 1 : 0)} disabledFor={(d) => !td.has(d)} onClick={onToggle} />
      <textarea data-testid="meal-dietary" value={dietary} onChange={(e) => onDietary(e.target.value)}
        placeholder="Food allergies or dietary restrictions (optional). Meals are enjoyed together with our coaches and camp staff."
        className="mt-3 w-full rounded-xl border-2 border-[#E2EBF0] px-3 py-2 text-sm focus:border-[#008057] outline-none" rows={2} />
    </div>
  );
}
